import { checkIfSameDay, getPastDate } from '../../utils/dateTimeUtils';

// Function to convert the start and end date as an input for ranges prop in date range picker
const getDateRangeInputValue = (range) => {
  return [
    {
      startDate: range?.startDate,
      endDate: range?.endDate,
      key: 'selection'
    }
  ];
};

// Function to build the static range
const buildStaticRange = (days, includeToday) => ({
  startDate: getPastDate(includeToday ? days - 1 : days), // If includeToday is true, subtract 1 day from the days value to get the start date
  endDate: includeToday ? new Date() : getPastDate(1) // If includeToday is true, set the end date to today, otherwise set it to yesterday
});

// Function to get the static ranges list
const getStaticRangesList = (staticRanges = [], includeToday = false) =>
  staticRanges.map(({ label, value: days }) => {
    const rangeFn = () => buildStaticRange(days, includeToday);

    return {
      label,
      range: rangeFn,
      isSelected({ startDate, endDate }) {
        const defined = rangeFn();
        return (
          checkIfSameDay(startDate, defined.startDate) && checkIfSameDay(endDate, defined.endDate)
        );
      }
    };
  });

export { getDateRangeInputValue, getStaticRangesList };
